/**
 * Catálogo genérico de productos y paquetes comerciales TNO Network.
 * Precios referenciales (USD/mes) alineados con propuestas aprobadas: GPM Eventos, LED Home,
 * patrocinio TNO Business, Chemical, Smart Training, Altamira Village, entre otras.
 */

/** Programas de referencia para bloques de entrevista / conversación en antena. */
export const entrevistaAnchorPrograms = [
  {
    name: 'Marketing en Movimiento',
    note: 'Entrevistas a expertas en marketing, economía y emprendimiento',
    href: 'https://tnonetwork.com/show/marketingenmovimiento',
    showSlug: 'marketingenmovimiento',
  },
  {
    name: 'Franquicias en Venezuela',
    note: 'Argenis Carpio · voceros y fundadores del ecosistema de franquicias',
    href: 'https://tnonetwork.com/show/franquiciasenvenezuela',
    showSlug: 'franquiciasenvenezuela',
  },
  {
    name: 'En Producción con MEM',
    note: 'María Eugenia Moreno · industria creativa y casos de marca',
    href: 'https://tnonetwork.com/show/enproduccionconmem',
    showSlug: 'enproduccionconmem',
  },
  {
    name: 'Legalmente en Familia',
    note: 'Leila Davogustto Luna · orientación legal y conversación en antena',
    href: 'https://tnonetwork.com/show/legalmenteenfamilia',
    showSlug: 'legalmenteenfamilia',
  },
  {
    name: '3 de Copas con Zidney',
    note: 'Conversación en profundidad · estilo de vida y transformación',
    href: 'https://tnonetwork.com/show/3decopas',
    showSlug: '3decopas',
  },
  {
    name: 'Comercio Corporativo',
    note: 'Darío Ascanio · líderes empresariales y gestión',
    href: 'https://tnonetwork.com/show/comerciocorporativo',
    showSlug: 'comerciocorporativo',
  },
  {
    name: 'La Dosis Positiva',
    note: 'Yanira Bocaranda · bienestar, productividad y crecimiento personal',
    href: 'https://tnonetwork.com/show/ladosispositiva',
    showSlug: 'ladosispositiva',
  },
  {
    name: 'TNO Business',
    note: 'Entrevistas a líderes, casos de éxito y coyuntura empresarial',
    href: 'https://tnonetwork.com/show/tnobusiness',
    showSlug: 'tnobusiness',
  },
];

export const PACKAGE_CATEGORIES = [
  { id: 'all', label: 'Ver todo' },
  { id: 'signal', label: 'Señal y antena' },
  { id: 'editorial', label: 'Digest y web' },
  { id: 'production', label: 'Producción y cobertura' },
  { id: 'bundles', label: 'Paquetes integrados' },
];

/** Productos unitarios (à la carte). */
export const commercialProducts = [
  {
    id: 'micros-rotativa',
    category: 'signal',
    name: 'Micros en rotativa diaria',
    price: 85,
    priceNote: 'USD / mes',
    frequency: 'Alta rotación en grilla 24/7',
    summary: 'Piezas cortas en la parrilla de Radio Visual TNO para recordación constante de marca.',
    includes: ['Video 15–30 s en grilla regular', 'Rotación diaria en señal multiplataforma', 'Ideal para fechas, ofertas y top of mind'],
    accent: '#00acc1',
    icon: 'broadcast',
  },
  {
    id: 'rotativa-12',
    category: 'signal',
    name: 'Rotativa 12 spots diarios',
    price: 100,
    priceNote: 'USD / mes · tarifa referencial propuestas',
    frequency: '24/7 · Radio Visual',
    summary: 'Presencia sostenida en antena con spots de marca distribuidos a lo largo del día.',
    includes: ['12 spots diarios (≈360 al mes)', 'Formato video 15–20 s', 'Reporte de rotación mensual'],
    accent: '#1565c0',
    icon: 'broadcast',
  },
  {
    id: 'mencion-marca-programa',
    category: 'signal',
    name: 'Mención de marca en programa',
    price: 50,
    priceNote: 'USD / mes',
    frequency: 'Apertura y cierre del programa',
    summary: 'Tu marca en la bienvenida y despedida del espacio: recordación clara sin spot completo.',
    includes: ['Mención verbal en presentación y cierre', 'Logo en apertura y despedida', 'Ideal para top of mind en un programa'],
    accent: '#5e35b1',
    icon: 'mic',
  },
  {
    id: 'publicidad-selectiva',
    category: 'signal',
    name: 'Publicidad selectiva en programa',
    price: 350,
    priceNote: 'USD / mes',
    frequency: '4 emisiones / semana',
    summary: 'Spot de 20 s en cortes comerciales del programa que elijas — precisión por vertical.',
    includes: ['Spot video 20 s', '4 pases semanales en programa acordado', 'Segmentación por nicho y audiencia'],
    accent: '#4527a0',
    icon: 'broadcast',
  },
  {
    id: 'rotativa-publicitaria',
    category: 'signal',
    name: 'Rotativa publicitaria (tarifario)',
    price: 540,
    priceNote: 'USD / mes',
    frequency: '12 emisiones diarias · vivo',
    summary: 'Tarifario estándar media kit: spot en cortes de toda la programación en vivo.',
    includes: ['Spot video 20 s', '12 emisiones diarias en grilla en vivo', 'Máximo alcance en señal TNO'],
    accent: '#1a237e',
    icon: 'broadcast',
  },
  {
    id: 'ghost-live-branding',
    category: 'signal',
    name: 'Ghost Live Branding',
    price: 200,
    priceNote: 'USD / mes',
    frequency: 'Transmisiones en vivo',
    summary: 'Presencia visual integrada en el set y menciones naturales durante la emisión.',
    includes: ['Branding en set del programa', 'Menciones en contexto editorial', 'Exposición premium en tiempo real'],
    accent: '#4a148c',
    icon: 'layers',
  },
  {
    id: 'menciones-selectivas',
    category: 'signal',
    name: 'Menciones selectivas en programas',
    price: 95,
    priceNote: 'USD / mes',
    frequency: 'Programas clave del ecosistema',
    summary: 'La marca se integra en vivo con menciones naturales en producciones de alto contexto.',
    includes: ['Menciones en antena acordadas', 'Integración al tono del programa', 'Sin cortes fríos invasivos'],
    accent: '#6a1b9a',
    icon: 'mic',
  },
  {
    id: 'lower-thirds',
    category: 'signal',
    name: 'Lower thirds y cintillos en vivo',
    price: 75,
    priceNote: 'USD / mes',
    frequency: 'Transmisiones en vivo',
    summary: 'Gráfica en pantalla durante programas seleccionados: logo, claim y CTA.',
    includes: ['Cintillo / lower third en vivo', 'Presencia en programas de afinidad', 'Arte adaptable por campaña'],
    accent: '#c2185b',
    icon: 'layers',
  },
  {
    id: 'segmento-mensual',
    category: 'signal',
    name: 'Segmento patrocinado mensual',
    price: 180,
    priceNote: 'USD / mes',
    frequency: '1 bloque dedicado / mes',
    summary: 'Bloque con narrativa de marca dentro de un programa ancla (no solo mención suelta).',
    includes: ['Segmento de 3–5 min en programa acordado', 'Guion alineado al vertical', 'Posible recorte para redes'],
    accent: '#2e7d32',
    icon: 'mic',
  },
  {
    id: 'entrevista-estudio',
    category: 'signal',
    name: 'Entrevista en estudio TNO',
    price: 150,
    priceNote: 'USD / mes · 1 bloque',
    frequency: '1 entrevista mensual',
    summary: 'Bloque en vivo desde estudio principal con producción multicámara y difusión en señal.',
    includes: ['Entrevista o pitch en estudio', 'Difusión en TNO Live', 'Contenido reutilizable en clips'],
    anchorPrograms: entrevistaAnchorPrograms,
    accent: '#0277bd',
    icon: 'studio',
  },
  {
    id: 'nota-prensa',
    category: 'editorial',
    name: 'Press release / nota de prensa',
    price: 20,
    priceNote: 'USD / publicación',
    frequency: 'TNO Digest',
    summary: 'Publicación en TNO Digest con SEO, imágenes y enlaces — tarifario media kit.',
    includes: ['Nota en tnonetwork.com', 'Indexación SEO en Google', 'Imágenes y enlaces externos'],
    accent: '#00796b',
    icon: 'article',
  },
  {
    id: 'pack-notas-10',
    category: 'editorial',
    name: 'Pack 10 notas de prensa',
    price: 150,
    priceNote: 'USD · pack',
    frequency: 'TNO Digest',
    summary: 'Diez publicaciones editoriales para campañas de lanzamiento o posicionamiento sostenido.',
    includes: ['10 notas en TNO Digest', 'SEO por pieza', 'Mejor costo por impacto editorial'],
    accent: '#00695c',
    icon: 'article',
  },
  {
    id: 'branded-content',
    category: 'editorial',
    name: 'Branded Content',
    price: 60,
    priceNote: 'USD / mes',
    frequency: 'Editorial patrocinado',
    summary: 'Contenido de valor con autoridad SEO: artículos y notas patrocinadas en el portal.',
    includes: ['Pieza editorial patrocinada', 'Posicionamiento en buscadores', 'Narrativa de marca con utilidad'],
    accent: '#00897b',
    icon: 'article',
  },
  {
    id: 'digest-articulo',
    category: 'editorial',
    name: 'Artículo TNO Digest (SEO)',
    price: 60,
    priceNote: 'USD / artículo',
    frequency: 'Publicación pautada',
    summary: 'Pieza editorial optimizada para buscadores en tnonetwork.com / TNO Digest.',
    includes: ['Redacción + SEO on-page', 'Imágenes y enlaces/CTA', 'Activo digital de largo plazo'],
    accent: '#00838f',
    icon: 'article',
  },
  {
    id: 'digest-pack-8',
    category: 'editorial',
    name: 'Pack Digest SEO (8 artículos/mes)',
    price: 120,
    priceNote: 'USD / mes',
    frequency: '2 artículos / semana',
    summary: 'Estrategia editorial continua para autoridad en Google y captación orgánica.',
    includes: ['8 artículos mensuales', 'Palabras clave acordadas', 'CTAs a landing o WhatsApp'],
    accent: '#006064',
    icon: 'article',
  },
  {
    id: 'logo-web-24',
    category: 'editorial',
    name: 'Logo aliado 24/7 en portal',
    price: 40,
    priceNote: 'USD / mes',
    frequency: 'Presencia permanente',
    summary: 'Espacio fijo en el bloque de aliados comerciales de tnonetwork.com.',
    includes: ['Banner / logo en portal', 'Enlace a sitio de la marca', 'Visible 24/7'],
    accent: '#5c6bc0',
    icon: 'web',
  },
  {
    id: 'banner-web-campana',
    category: 'editorial',
    name: 'Banner web + campaña digital',
    price: 65,
    priceNote: 'USD / mes',
    frequency: 'Portal TNO Network',
    summary: 'Pieza gráfica rotativa en espacios editoriales de alto tráfico.',
    includes: ['Banner horizontal o vertical', 'CTA medible', 'Rotación creativa mensual'],
    accent: '#3949ab',
    icon: 'web',
  },
  {
    id: 'banner-ads-network',
    category: 'editorial',
    name: 'Banner Ads Network',
    price: 80,
    priceNote: 'USD / mes',
    frequency: 'Portal TNO Network',
    summary: 'Banner estratégico en tnonetwork.com con enlace a tu sitio y medición de clics.',
    includes: ['Banner gráfico en portal', 'Enlace a landing o web', 'Tracking de clics y conversiones'],
    accent: '#303f9f',
    icon: 'web',
  },
  {
    id: 'social-insert',
    category: 'production',
    name: 'Social Insert',
    price: 120,
    priceNote: 'USD / mes',
    frequency: 'Reels / TikTok',
    summary: 'Inserción de marca en clips editados para redes con potencial viral.',
    includes: ['Contenido en formato Reels/TikTok', 'Edición optimizada por plataforma', 'Distribución en ecosistema TNO'],
    accent: '#c51162',
    icon: 'ugc',
  },
  {
    id: 'ugc-mensual',
    category: 'production',
    name: 'Paquete UGC mensual',
    price: 80,
    priceNote: 'USD / mes',
    frequency: 'Contenido para redes',
    summary: 'Piezas estilo creador (review, unboxing, testimonial) para Instagram y TikTok.',
    includes: ['4–6 piezas UGC guiadas', 'Formato cercano y auténtico', 'Entrega lista para publicar'],
    accent: '#d81b60',
    icon: 'ugc',
  },
  {
    id: 'produccion-insitu',
    category: 'production',
    name: 'Producción in situ',
    price: 120,
    priceNote: 'USD / mes · 2 jornadas',
    frequency: 'Grabación en sede / tienda',
    summary: 'Cobertura profesional en punto de venta o evento con piezas para señal y redes.',
    includes: ['2 jornadas de grabación/mes', 'Showroom, producto o activación', 'Material para rotativa y redes'],
    accent: '#e65100',
    icon: 'camera',
  },
  {
    id: 'cobertura-express',
    category: 'production',
    name: 'Cobertura express en feria / evento',
    price: 220,
    priceNote: 'USD / activación',
    frequency: 'Por evento',
    summary: 'Equipo TNO en terreno: recorrido, entrevistas rápidas y piezas de cierre.',
    includes: ['Cobertura en feria o lanzamiento', 'Micros y fotos para redes', 'Entrega en 48–72 h post-evento'],
    accent: '#ef6c00',
    icon: 'event',
  },
  {
    id: 'redes-colab',
    category: 'production',
    name: 'Difusión en redes del ecosistema',
    price: 55,
    priceNote: 'USD / mes',
    frequency: 'Menciones orgánicas',
    summary: 'La marca aparece en historias y publicaciones de @tnonetwork y programas aliados.',
    includes: ['Menciones en historias IG', 'Cruces con programas del ecosistema', 'Refuerzo de campaña en antena'],
    accent: '#ad1457',
    icon: 'share',
  },
];

/** Paquetes integrados (referencia de propuestas tipo LED Home, GPM, patrocinio programa). */
export const commercialBundles = [
  {
    id: 'esencial',
    category: 'bundles',
    name: 'Presencia Esencial',
    price: 290,
    priceNote: 'USD / mes',
    badge: 'Arranque recomendado',
    summary: 'Recordación en antena + presencia web + autoridad editorial básica.',
    accent: '#1565c0',
    items: [
      { label: 'Rotativa 12 spots diarios', value: 'Incluido' },
      { label: 'Logo aliado 24/7 en portal', value: 'Incluido' },
      { label: 'TNO Digest', value: '2 artículos SEO / mes' },
      { label: 'Menciones selectivas', value: '2 / mes' },
    ],
    idealFor: 'Marcas que inician en TNO y buscan visibilidad sostenida sin producción compleja.',
  },
  {
    id: 'crecimiento',
    category: 'bundles',
    name: 'Presencia Growth',
    price: 460,
    priceNote: 'USD / mes',
    badge: 'Más vendido',
    summary: 'El equilibrio entre señal, contenido orgánico y SEO — referencia LED Home / GPM.',
    accent: '#00838f',
    highlighted: true,
    items: [
      { label: 'Todo Presencia Esencial', value: 'Incluido' },
      { label: 'Micros en rotativa diaria', value: 'Incluido' },
      { label: 'Pack Digest SEO', value: '8 artículos / mes' },
      { label: 'Paquete UGC mensual', value: 'Incluido' },
      { label: 'Lower thirds en programas clave', value: 'Incluido' },
    ],
    idealFor: 'Marcas que quieren embudo completo: recordación, confianza y tráfico digital.',
  },
  {
    id: 'autoridad',
    category: 'bundles',
    name: 'Presencia Autoridad',
    price: 650,
    priceNote: 'USD / mes',
    badge: 'Máximo impacto',
    summary: '360° comercial: antena, estudio, producción en terreno y editorial fuerte.',
    accent: '#6a1b9a',
    items: [
      { label: 'Todo Presencia Growth', value: 'Incluido' },
      { label: 'Entrevista mensual en estudio', value: 'Incluido' },
      { label: 'Producción in situ (2 jornadas)', value: 'Incluido' },
      { label: 'Segmento patrocinado mensual', value: '1 programa' },
      { label: 'Cobertura express', value: '1 evento / trimestre' },
    ],
    idealFor: 'Lanzamientos, temporadas altas o posicionamiento premium en el ecosistema.',
  },
];

/** IDs destacados en el teaser del home. */
export const TEASER_FEATURED_PRODUCT_IDS = [
  'rotativa-publicitaria',
  'publicidad-selectiva',
  'nota-prensa',
  'social-insert',
];

export const getTeaserFeaturedProducts = () =>
  TEASER_FEATURED_PRODUCT_IDS.map((id) => commercialProducts.find((p) => p.id === id)).filter(Boolean);

export const countCommercialOffers = () => commercialProducts.length + commercialBundles.length;

export const packagesPageCopy = {
  heroOverline: 'TNO Network · Portafolio comercial',
  heroTitle: 'Productos y paquetes',
  heroSubtitle:
    'Inventario genérico para armar propuestas: micros, rotativas, menciones selectivas, Digest, coberturas y paquetes integrados. Precios referenciales en USD/mes.',
  disclaimer:
    'Los montos son referencia orientativa según propuestas recientes del media kit. El plan final se ajusta por rubro, exclusividad, calendario y volumen de piezas.',
  ctaLabel: 'Armar propuesta con comercial',
};

export default commercialProducts;
